import { makeStyles } from "@fluentui/react-components";
import { MAPLIBRE_Z_INDEX } from "../../../utils/maps/MapConstants";

export const mapLibreStyles = makeStyles({
  mapContainer: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    minHeight: "520px",
    borderRadius: "8px",
    overflow: "hidden",
    zIndex: 0,
  },
  embeddedMapContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    minHeight: "240px",
    borderRadius: "8px",
    overflow: "hidden",
  },
  map: {
    width: "100%",
    height: "100%",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  mapControlContainer: {
    position: "absolute",
    top: "12px",
    right: "12px",
    fontWeight: 500,
    zIndex: MAPLIBRE_Z_INDEX.CONTROL,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  // errors: {
  //   position: "absolute",
  //   top: 0,
  //   left: 0,
  //   right: 0,
  //   zIndex: 3,
  //   pointerEvents: "none",
  // },
  markerButton: {
    border: 0,
    padding: 0,
    margin: 0,
    background: "transparent",
    cursor: "pointer",
    display: "block",
  },
  airportMarker: {
    width: "30px",
    height: "40px",
    display: "block",
  },
  flightMarker: {
    width: "35px",
    height: "35px",
    display: "block",
  },
  selectedFlightMarker: {
    width: "40px",
    height: "40px",
  },
  gateMarker: {
    display: "block",
    width: "30px",
    height: "30px",
    border: "2px solid #fff",
    borderRadius: "50%",
    boxShadow: "0 1px 3px rgba(0,0,0,0.35)",
    boxSizing: "border-box",
    fontSize: "10px",
    fontWeight: 700,
    lineHeight: "26px",
    textAlign: "center",
    color: "#000",
    userSelect: "none",
  },
});

export const mapDisplayErrorStyles = makeStyles({
  airportMap: {
    right: "0px",
    marginTop: "44px",
  },
  flightMap: {
    right: "180px",
  },
  singleFlightMap: {
    right: "0px",
  },
});

export const mapLibreControlsStyles = makeStyles({
  cardContainer: {
    padding: "8px",
    backgroundColor: "rgba(255,255,255,0.75)",
    backdropFilter: "saturate(180%) blur(6px)",
    borderRadius: "8px",
    border: "1px solid rgba(0,0,0,0.2)",
  },
  toggleControls: {
    display: "flex",
    flexDirection: "column",
  },
  viewControls: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  viewControlsLabel: {
    textAlign: "center",
    padding: "8px",
  },
  viewButton: {
    margin: "0 8px",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 500,
  },
});
